import ChargeHelper from 'features/Charge/chargeHelper';
import KTFormSearch from 'general/components/OtherKeenComponents/Forms/KTFormSearch';
import KTBSDropdown from 'general/components/OtherKeenComponents/KTBSDropdown';
import { KTBSDropdownDirections } from 'general/components/OtherKeenComponents/KTBSDropdown';
import CustomDateRangePicker, {
  dateFilter,
  getDateFilterOption,
} from 'general/components/Others/CustomDateRangePicker';
import AppColors from 'general/constants/AppColors';
import AppConfigs from 'general/constants/AppConfigs';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import DriverCustomerFilterDropdown from '../DriverCustomerFilterDropdown';
import _ from 'lodash';

DriverTopUpHistoryFilterView.propTypes = {
  onCancel: PropTypes.func,
  onApply: PropTypes.func,
  initialFilter: PropTypes.object,
};

function DriverTopUpHistoryFilterView({ onCancel, onApply, closeDropdown, initialFilter }) {
  // MARK: ---- PROPERTIES ----
  const [filterQ, setFilterQ] = useState('');
  const [filterStatus, setFilterStatus] = useState('');
  const [filterUserId, setFilterUserId] = useState('');
  const [selectedDriver, setSelectedDriver] = useState(null);
  const [filterFundingSource, setFilterFundingSource] = useState('');
  const [filterDateFilter, setFilterDateFilter] = useState(null);
  const [filterFrom, setFilterFrom] = useState('');
  const [filterTo, setFilterTo] = useState('');
  useEffect(() => {
    setFilterQ(initialFilter?.q ?? '');
    setFilterStatus(initialFilter?.status);
    setFilterUserId(initialFilter?.userId ?? '');
    setSelectedDriver(null);
    setFilterFundingSource(initialFilter?.fundingSource ?? '');
    setFilterDateFilter(initialFilter?.dateFilter);
    setFilterFrom(initialFilter?.from);
    setFilterTo(initialFilter?.to);
  }, [initialFilter]);

  // MARK: ---- METHODS ----
  const handleApplyFilter = () => {
    const newFilter = {
      page: 0,
      limit: AppConfigs.defaultPageLimit,
      q: filterQ,
      status: filterStatus,
      userId: filterUserId,
      fundingSource: filterFundingSource,
      dateFilter: filterDateFilter,
      from: filterFrom,
      to: filterTo,
    };
    if (onApply) onApply(newFilter);
    if (closeDropdown) closeDropdown();
  };
  const handleClearFilter = () => {
    const newFilter = {
      page: 0,
      limit: AppConfigs.defaultPageLimit,
      q: '',
      status: '',
      userId: '',
      fundingSource: '',
      from: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[0].format('YYYY-MM-DD'),
      to: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[1].format('YYYY-MM-DD'),
      dateFilter: dateFilter.baMuoiNgayGanNhat,
    };
    if (onCancel) onCancel(newFilter);
    if (closeDropdown) closeDropdown();
  };

  const dropdownDirection = Utils.isValid(initialFilter?.hasAppTab)
    ? KTBSDropdownDirections.up
    : KTBSDropdownDirections.down;

  return (
    <div className="py-4">
      <div className="row m-0 px-2">
        {/* tim kiem */}
        <div className="col-12 mb-4 px-2">
          <KTFormSearch
            name="search_filter"
            placeholder="Theo mã giao dịch, tên khách hàng, số điện thoại, số CCCD, nội dung..."
            value={filterQ}
            onSubmit={(text) => {
              setFilterQ(text);
            }}
          />
        </div>
        {/* trang thai */}
        <div className="col-6 mb-4 p-0 px-2">
          {UIHelper.buildFormLabel('Trạng thái')}
          <KTBSDropdown
            name="status_filter"
            toggleElement={
              <button
                className="btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                type="button"
              >
                {_.find(
                  ChargeHelper.Data.walletTransactionStatusOptions,
                  (item) => item.value === filterStatus
                )?.name ?? 'Tất cả'}
              </button>
            }
            selectedValue={filterStatus}
            dropdownMenuItems={[
              { name: 'Tất cả', value: '' },
              ...ChargeHelper.Data.walletTransactionStatusOptions,
            ]}
            dropdownMenuClassName="overflow-auto w-100"
            dropdownMenuStyle={{ maxHeight: '30vh' }}
            onChange={(value) => {
              setFilterStatus(value);
            }}
            isDropdownForm={true}
          />
        </div>
        {/* khach hang */}
        <div className="col-6 mb-4 px-2">
          {UIHelper.buildFormLabel('Khách hàng')}
          <DriverCustomerFilterDropdown
            selectedDriver={selectedDriver}
            onChange={(value) => {
              setSelectedDriver(value);
              setFilterUserId(value?.id ?? '');
            }}
            direction={dropdownDirection}
          />
        </div>
        {/* phuong thuc thanh toan */}
        <div className="col-6 mb-4 p-0 px-2">
          {UIHelper.buildFormLabel('Phương thức thanh toán')}
          <KTBSDropdown
            name="fundingSource_filter"
            toggleElement={
              <button
                className="btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                type="button"
              >
                {_.find(
                  ChargeHelper.Data.driverTopUpPaymentMethodOptions,
                  (item) => item.value === filterFundingSource
                )?.name ?? 'Tất cả'}
              </button>
            }
            selectedValue={filterFundingSource}
            dropdownMenuItems={[
              { name: 'Tất cả', value: '' },
              ...ChargeHelper.Data.driverTopUpPaymentMethodOptions,
            ]}
            dropdownMenuClassName="overflow-auto w-100"
            dropdownMenuStyle={{ maxHeight: '30vh' }}
            onChange={(value) => {
              setFilterFundingSource(value);
            }}
            isDropdownForm={true}
          />
        </div>
        {/* khoang thoi gian */}
        <div className="col-6 mb-4 p-0 px-2">
          {UIHelper.buildFormLabel('Khoảng thời gian')}
          <CustomDateRangePicker
            toggleElementBorderRadius={5}
            initialValue={filterDateFilter}
            onPressSave={(selectedValue, startDate, endDate) => {
              setFilterDateFilter(selectedValue);
              setFilterFrom(startDate);
              setFilterTo(endDate);
            }}
            direction={dropdownDirection}
          />
        </div>
      </div>
      {/* actions */}
      <div
        className="px-4 pt-4 pb-0 d-flex align-items-center justify-content-end gap-3"
        style={{
          borderTop: `1px solid ${AppColors.gray[200]}`,
        }}
      >
        <div className="d-flex gap-3">
          {UIHelper.buildNegativeButton('Xóa bộ lọc', handleClearFilter)}
          {UIHelper.buildGreenButton('Áp dụng', handleApplyFilter)}
        </div>
      </div>
    </div>
  );
}

export default DriverTopUpHistoryFilterView;
